
class LinkService {
  getLink() {
    // return 'http://localhost:8081'
    return 'https://api.nilin.ci2ict.com'
  }
}

export default new LinkService();